module.exports = __webpack_public_path__ + "img/user-management.3777f016.svg";